import templateUrl from './planning-resources-reference-map.html';

export const planningResourcesReferenceMapComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class PlanningResourcesReferenceMapComponent {
		constructor($sce, PlanningResourcesReferenceMapService) {
			'ngInject';

            this.$sce = $sce;
			this.planningResourcesReferenceMapService = PlanningResourcesReferenceMapService;
		}

		$onInit() {
			this.details = this.planningResourcesReferenceMapService.getPlanningResourcesReferenceMapDetails(this.details.data.content);
			this.details.description = this.$sce.trustAsHtml(this.details.description);
            this.details.embedCode = this.$sce.trustAsHtml(this.details.embedCode);
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-reference-map/planning-resources-reference-map.component.js